import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
export default function Footer() {
    return (
        <footer className="level section has-background-light is-full-width">
            <div className="level-left">
                <div className="level-item">
                    <p className="is-size-6 has-text-grey">
                        Copyright © {new Date().getFullYear()} CSEA NIT Andhra
                        Pradesh. All rights reserved.
                    </p>
                </div>
            </div>
            <div className="level-right">
                <div className="level is-mobile">
                    <div className="level-item is-clickable">
                        <a
                            href="https://www.facebook.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaFacebook color="#4267B2" size="25" />
                        </a>
                    </div>
                    <div className="level-item is-clickable">
                        <a
                            href="https://www.instagram.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaInstagram color="#8a3ab9" size="25" />
                        </a>
                    </div>
                    <div className="level-item is-clickable">
                        <a
                            href="https://www.linkedin.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaLinkedin color="#0077b5" size="25" />
                        </a>
                    </div>
                    <div className="level-item is-clickable">
                        <a
                            href="mailto:csea@nitandhra.ac.in"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <SiGmail color="#DB4437" size="25" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
